import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';

import Iconify from 'src/components/iconify';
import { useSettingsContext } from 'src/components/settings';
import { useResponsive } from 'src/hooks/use-responsive';
import { bgBlur } from 'src/theme/css';

import { MouseEventHandler } from 'react';
import { NAV } from '../config-layout';

// ----------------------------------------------------------------------

type NavToggleButtonProps = IconButtonProps & {
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export default function NavToggleButton({ sx, onClick, ...other }: NavToggleButtonProps) {
  const theme = useTheme();
  const settings = useSettingsContext();
  const lgUp = useResponsive('up', 'lg');

  if (!lgUp) {
    return null;
  }

  return (
    <IconButton
      size="small"
      onClick={onClick ?? (() =>
        settings.onUpdate('themeLayout', settings.themeLayout === 'vertical' ? 'mini' : 'vertical')
      )}
      sx={{
        p: 0.5,
        top: 26.5,
        position: 'fixed',
        left: NAV.W_VERTICAL - 12,
        zIndex: 1300,
        border: `dashed 1px ${theme.palette.divider}`,
        ...bgBlur({ opacity: 0.48, color: theme.palette.background.default }),
        '&:hover': {
          bgcolor: 'background.default',
        },
        ...sx,
      }}
      {...other}
    >
      <Iconify
        width={16}
        icon={
          settings.themeLayout === 'vertical'
            ? 'eva:arrow-ios-back-fill'
            : 'eva:arrow-ios-forward-fill'
        }
      />
    </IconButton>
  );
}
